module.exports = __webpack_public_path__ + "static/media/ctc_bg.3652d732.gif";